<template>
  <div>
    <alert ref="alert"></alert>
    <v-card shaped outlined class="menucard form mx-auto mt-8" width="900px">
      <v-card-title class="title">
        {{ siteText.ui.otpVerificationHeader }}
      </v-card-title>

    <v-card-text class="card-header" id="otpInfo">
      {{ siteText.ui.optVerificationInfo }}
    </v-card-text>

    <v-card-text>
      <v-text-field
        ref="otpField"
        v-model="otp"
        :label="siteText.ui.otpVerificationLabel"
        dense
        required
        autofocus
        validate-on-blur
        aria-describedby="otpInfo"
        @focus="onFocus"
        @blur="onBlur"
        @keydown.native="onKeydown"
        @paste.native="onPaste"
        :rules="[otpRule]"
      ></v-text-field>

      <v-btn
        block
        large
        color="public-blue"
        class="white--text mt-4"
        :disabled="!otpIsValid"
        @click="verifyOtp"
      >
        {{ siteText.ui.otpVerificationButton }}
      </v-btn>
    </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Alert from '../components/Alert.vue';

export default {
  components: {
    Alert
  },
  name: "OtpVerification",
  injectModels: ["PublicWebSite"],
  data() {
    return {
      otp: "",
      touched: false
    };
  },
  computed: {
    ...mapGetters(['siteText']),
    // only enable when exactly 8 alphanumeric chars
    otpIsValid() {
      return /^[0-9]+$/.test(this.otp);
    },
    // only show error if they've blurred, entered at least one char, but <8
    otpRule() {
      return () => {
        if (!this.touched) return true;
        // if ((v || "").length < 8) {
        //   return this.PublicWebSite.Text.OTP_Rule_OTP_Requird;
        // }
        return true;
      };
    }
  },
  methods: {
    onFocus() {
      this.touched = false;
      this.$refs.otpField.resetValidation();
    },
    onBlur() {
      this.touched = true;
      this.$refs.otpField.validate();
    },
    // block any non-alphanumeric keypress, allow navigation & ctrl/meta combos
    onKeydown(e) {
      const char = e.key;
      const isNavKey =
        e.key.length > 1 || // Arrow keys, Backspace, Delete, etc.
        e.ctrlKey ||
        e.metaKey;
      if (isNavKey) return;
      if (!/^[0-9]+$/.test(char)) {
        e.preventDefault();
      }
    },
    // sanitize pasted text: strip non-alphanumerics, truncate to fit
    onPaste(e) {
      e.preventDefault();
      const pasted = e.clipboardData
        .getData("text")
        .replace(/[^A-Za-z0-9]/g, "");
      const spaceLeft = 8 - this.otp.length;
      if (spaceLeft <= 0) return;
      this.otp += pasted.slice(0, spaceLeft);
    },
    verifyOtp() {
      this.$emit("VerifyOtp", this.otp);
    },
    async showAlert(title, message) {
      return this.$refs.alert.open(title, message);
    },
    focusOtpField() {
      this.$nextTick(() => {
        if (this.$refs.otpField && this.$refs.otpField.$el) {
          this.$refs.otpField.$el.querySelector('input').focus();
        }
      });
    }
  }
};
</script>

<style scoped>
.menucard {
  margin-top: 20px;
  padding: 10px;
}
.card-header {
  color: rgba(0, 0, 0, 0.6) !important;
}
.title {
  margin-top: -40px;
  background-color: white !important;
  max-width: 350px;
  margin-left: 50px;
}
.v-input {
  font-size: 18px;
}
</style>
